import Color from '../Color.mjs'
import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.ORANGE,
    name: '规则模型',
    type: 'CAT_RULEM',
}
